const DestroySessionVariableByName = "DestroySessionVariableByName"
const DestroySessionVariableById = "DestroySessionVariableById"
const ExpandExpression = "ExpandExpression"
const GetVariables = "GetVariables"
const GetScriptEx = "GetScriptEx"
const GetFieldAndColumnSamples = "GetFieldAndColumnSamples"
const SearchObjects = "SearchObjects"
const SearchResults = "SearchResults"
const SelectAssociations = "SelectAssociations"
const SearchAssociations = "SearchAssociations"
const SearchSuggest = "SearchSuggest"
const SendGenericCommandToCustomConnector = "SendGenericCommandToCustomConnector"
const GetFileTablesEx = "GetFileTablesEx"
const GetFileTablePreview = "GetFileTablePreview"
const GetFileTableFields = "GetFileTableFields"
const GetFileTables = "GetFileTables"
const GuessFileType = "GuessFileType"
const GetFolderItemsForConnection = "GetFolderItemsForConnection"
const GetDatabaseTablePreview = "GetDatabaseTablePreview"
const GetDatabaseTableFields = "GetDatabaseTableFields"
const GetDatabaseTables = "GetDatabaseTables"
const GetDatabaseOwners = "GetDatabaseOwners"
const GetDatabases = "GetDatabases"
const GetDatabaseInfo = "GetDatabaseInfo"
const GetConnections = "GetConnections"
const GetConnection = "GetConnection"
const DeleteConnection = "DeleteConnection"
const ModifyConnection = "ModifyConnection"
const CreateConnection = "CreateConnection"
const GetIncludeFileContent = "GetIncludeFileContent"
const SetFavoriteVariables = "SetFavoriteVariables"
const GetFavoriteVariables = "GetFavoriteVariables"
const CheckScriptSyntax = "CheckScriptSyntax"
const SetScript = "SetScript"
const GetSetAnalysis = "GetSetAnalysis"
const ForwardCount = "ForwardCount"
const BackCount = "BackCount"
const DoReloadEx = "DoReloadEx"
const GetLibraryContent = "GetLibraryContent"
const GetContentLibraries = "GetContentLibraries"
const GetMediaList = "GetMediaList"
const GetAssociationScores = "GetAssociationScores"
const SaveObjects = "SaveObjects"
const Scramble = "Scramble"
const FindMatchingFields = "FindMatchingFields"
const GetMatchingFields = "GetMatchingFields"
const Publish = "Publish"
const AbortModal = "AbortModal"
const Resume = "Resume"
const GetAllInfos = "GetAllInfos"
const GetFieldOnTheFlyByName = "GetFieldOnTheFlyByName"
const AddFieldFromExpression = "AddFieldFromExpression"
const CloneBookmark = "CloneBookmark"
const ApplyBookmark = "ApplyBookmark"
const GetBookmark = "GetBookmark"
const DestroyBookmark = "DestroyBookmark"
const CreateBookmark = "CreateBookmark"
const RemoveAlternateState = "RemoveAlternateState"
const AddAlternateState = "AddAlternateState"
const CheckNumberOrExpression = "CheckNumberOrExpression"
const CheckExpression = "CheckExpression"
const GetVariableByName = "GetVariableByName"
const GetVariableById = "GetVariableById"
const DestroyVariableByName = "DestroyVariableByName"
const DestroyVariableById = "DestroyVariableById"
const CreateVariableEx = "CreateVariableEx"
const DestroySessionVariable = "DestroySessionVariable"
const CreateSessionVariable = "CreateSessionVariable"
const CloneMeasure = "CloneMeasure"
const GetMeasure = "GetMeasure"
const DestroyMeasure = "DestroyMeasure"
const CreateMeasure = "CreateMeasure"
const CloneDimension = "CloneDimension"
const GetDimension = "GetDimension"
const DestroyDimension = "DestroyDimension"
const CreateDimension = "CreateDimension"
const ClearUndoBuffer = "ClearUndoBuffer"
const Redo = "Redo"
const Undo = "Undo"
const DestroyDraft = "DestroyDraft"
const CommitDraft = "CommitDraft"
const CreateDraft = "CreateDraft"
const CloneObject = "CloneObject"
const GetBookmarks = "GetBookmarks"
const GetObjects = "GetObjects"
const GetObject = "GetObject"
const DestroyObject = "DestroyObject"
const CreateObject = "CreateObject"
const DestroySessionObject = "DestroySessionObject"
const CreateSessionObject = "CreateSessionObject"
const GetLineage = "GetLineage"
const GetAppProperties = "GetAppProperties"
const SetAppProperties = "SetAppProperties"
const GetAppLayout = "GetAppLayout"
const GetTableData = "GetTableData"
const DoSave = "DoSave"
const SetFetchLimit = "SetFetchLimit"
const GetTextMacros = "GetTextMacros"
const GetScript = "GetScript"
const SetScriptBreakpoints = "SetScriptBreakpoints"
const GetScriptBreakpoints = "GetScriptBreakpoints"
const DoReload = "DoReload"
const GetEmptyScript = "GetEmptyScript"
const SetViewDlgSaveInfo = "SetViewDlgSaveInfo"
const GetViewDlgSaveInfo = "GetViewDlgSaveInfo"
const GetTablesAndKeys = "GetTablesAndKeys"
const GetLocaleInfo = "GetLocaleInfo"
const RemoveVariable = "RemoveVariable"
const CreateVariable = "CreateVariable"
const Forward = "Forward"
const Back = "Back"
const UnlockAll = "UnlockAll"
const LockAll = "LockAll"
const ClearAll = "ClearAll"
const EvaluateEx = "EvaluateEx"
const Evaluate = "Evaluate"
const SetLooselyCoupledVector = "SetLooselyCoupledVector"
const GetLooselyCoupledVector = "GetLooselyCoupledVector"
const GetVariable = "GetVariable"
const GetFieldDescription = "GetFieldDescription"
const GetField = "GetField"
export { GetField };
export { GetFieldDescription };
export { GetVariable };
export { GetLooselyCoupledVector };
export { SetLooselyCoupledVector };
export { Evaluate };
export { EvaluateEx };
export { ClearAll };
export { LockAll };
export { UnlockAll };
export { Back };
export { Forward };
export { CreateVariable };
export { RemoveVariable };
export { GetLocaleInfo };
export { GetTablesAndKeys };
export { GetViewDlgSaveInfo };
export { SetViewDlgSaveInfo };
export { GetEmptyScript };
export { DoReload };
export { GetScriptBreakpoints };
export { SetScriptBreakpoints };
export { GetScript };
export { GetTextMacros };
export { SetFetchLimit };
export { DoSave };
export { GetTableData };
export { GetAppLayout };
export { SetAppProperties };
export { GetAppProperties };
export { GetLineage };
export { CreateSessionObject };
export { DestroySessionObject };
export { CreateObject };
export { DestroyObject };
export { GetObject };
export { GetObjects };
export { GetBookmarks };
export { CloneObject };
export { CreateDraft };
export { CommitDraft };
export { DestroyDraft };
export { Undo };
export { Redo };
export { ClearUndoBuffer };
export { CreateDimension };
export { DestroyDimension };
export { GetDimension };
export { CloneDimension };
export { CreateMeasure };
export { DestroyMeasure };
export { GetMeasure };
export { CloneMeasure };
export { CreateSessionVariable };
export { DestroySessionVariable };
export { CreateVariableEx };
export { DestroyVariableById };
export { DestroyVariableByName };
export { GetVariableById };
export { GetVariableByName };
export { CheckExpression };
export { CheckNumberOrExpression };
export { AddAlternateState };
export { RemoveAlternateState };
export { CreateBookmark };
export { DestroyBookmark };
export { GetBookmark };
export { ApplyBookmark };
export { CloneBookmark };
export { AddFieldFromExpression };
export { GetFieldOnTheFlyByName };
export { GetAllInfos };
export { Resume };
export { AbortModal };
export { Publish };
export { GetMatchingFields };
export { FindMatchingFields };
export { Scramble };
export { SaveObjects };
export { GetAssociationScores };
export { GetMediaList };
export { GetContentLibraries };
export { GetLibraryContent };
export { DoReloadEx };
export { BackCount };
export { ForwardCount };
export { GetSetAnalysis };
export { SetScript };
export { CheckScriptSyntax };
export { GetFavoriteVariables };
export { SetFavoriteVariables };
export { GetIncludeFileContent };
export { CreateConnection };
export { ModifyConnection };
export { DeleteConnection };
export { GetConnection };
export { GetConnections };
export { GetDatabaseInfo };
export { GetDatabases };
export { GetDatabaseOwners };
export { GetDatabaseTables };
export { GetDatabaseTableFields };
export { GetDatabaseTablePreview };
export { GetFolderItemsForConnection };
export { GuessFileType };
export { GetFileTables };
export { GetFileTableFields };
export { GetFileTablePreview };
export { GetFileTablesEx };
export { SendGenericCommandToCustomConnector };
export { SearchSuggest };
export { SearchAssociations };
export { SelectAssociations };
export { SearchResults };
export { SearchObjects };
export { GetFieldAndColumnSamples };
export { GetScriptEx };
export { GetVariables };
export { ExpandExpression };
export { DestroySessionVariableById };
export { DestroySessionVariableByName };